import { ActionType } from "typesafe-actions";
import { select, call, put, takeLatest } from "redux-saga/effects";
import * as bankActions from "./actions";
import * as commonActions from "../actions";
import * as accountProfileSelectors from "../AccountProfile/selectors";
import * as bankSelectors from "./selectors";
import * as commonSelectors from "../selectors";
import * as countrySelectors from "src/ipm-shared/store/model/Country/selectors";
import { RootState } from "../reducers";
import { reTryTakeLatest } from "src/ipm-shared/Utils/ReduxSagaEffects";
import HttpRequestError from "src/ipm-shared/Utils/Exceptions/HttpRequestError";
import RestClient from "src/ipm-shared/services/Rest";
import * as formSelectors from "src/ipm-shared/components/Form/selectors";
import { BULK_REQUEST_FORM } from "../Payment/const";
import _get from "lodash-es/get";
import * as formActions from "src/ipm-shared/components/Form/actions";

const actions = {
  ...bankActions,
  ...commonActions
};

const selectors = {
  ...bankSelectors,
  ...commonSelectors,
  ...accountProfileSelectors,
  ...countrySelectors
};
const watchedSagas = [
  reTryTakeLatest(actions.fetchBanks, handleFetchBanks),
  takeLatest(actions.addBank, handleAdminAddBank)
];
export default watchedSagas;

export function* handleFetchBanks(
  action: ActionType<typeof actions.fetchBanks>
) {
  yield put(actions.setBanks({ isFetching: true, banks: [] }));
  const state: RootState = yield select();
  const isAdminView = selectors.isAdminRole(state);
  const currentCountry = selectors.getCurrentCountry(state);
  let countryCode = action.payload.countryCode;

  if (countryCode === "getAll" || isAdminView) {
    countryCode = undefined; // Undefined mean fetch all
  } else if (countryCode === undefined) {
    countryCode = currentCountry;
  }

  const res = yield call(RestClient.send, {
    query: {
      country: countryCode
    },
    service: "get_banks"
  });

  if (!res) {
    throw new HttpRequestError("Failed to fetch");
  }

  try {
    const banks = res.data.map((bank: any) => ({
      countryId: bank.country_id,
      displayName: bank.display_name,
      id: bank.id,
      isDeleted: bank.is_deleted,
      name: bank.name,
      swiftCode: bank.swift_code
    }));

    yield put(
      actions.setBanks({
        banks,
        isFetching: false
      })
    );
  } catch (e) {
    window.Logger.error("handleFetchBanks: ", e.message);
  }
}

export function* handleAdminAddBank(
  action: ActionType<typeof actions.addBank>
) {
  const state: RootState = yield select();
  const formState = formSelectors.getControls(state, BULK_REQUEST_FORM);
  const countryId = _get(formState, "bank_country_id.value");
  const bankName = _get(formState, "bank_name.value");
  const swiftCode = _get(formState, "swift_code.value");
  const isInternalBank = _get(formState, "is_internal_bank.value", "n");

  const res = yield call(RestClient.send, {
    body: {
      country_id: countryId,
      bank_name: bankName,
      swift_code: swiftCode,
      is_internal_bank: isInternalBank === "y" ? true : false
    },
    service: "add_bank",
    showGlobalLoader: true
  });

  if (!res) {
    return;
  }

  try {
    const errors = _get(res, "errors", undefined);

    if (errors) {
      yield put(formActions.parseServerErrors(errors, BULK_REQUEST_FORM));
      return;
    }
    yield put(formActions.resetFormValues(BULK_REQUEST_FORM));
    yield put(actions.toast("Sent request successfully!"));
  } catch (e) {
    window.Logger.error("handleAdminAddBank: ", e.message);
  }
}
